module.exports = __webpack_public_path__ + "static/agent_effenciency-18385c6f30a324c61f01c21822092c8d.svg";